/* eslint-disable import/no-cycle */
import { createGlobalStyle } from 'styled-components';
import { fonts, colors, measures } from '.';

const GlobalStyle = createGlobalStyle`
  html, body, #root {
    margin: 0px;
    padding: 0px;
    height: 100%;
    flex: 1;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.darkBlue};
    overflow: hidden;

    [class*='MuiList-root-'] {
      padding: 0px!important;

      li {
        font-size: 12px!important;
      }
    }

    div {
      &::-webkit-scrollbar { width: 0!important; height: 0!important; }
      overflow: -moz-scrollbars-none!important;
      -ms-overflow-style: none!important;
    }
    .toast-config {
      min-height: 30px!important;
      flex: 1;
      display: flex;
      font-size: 12px!important;
    }
  }

  html, body, #root, span, div, p, h1, h2, h3, a {
    font-family: Nunito, "Apple Color Emoji", "Noto Color Emoji", "Segoe UI Emoji", sans-serif !important;
    letter-spacing: 0.05em!important;
  }

  .shadow {
    box-shadow: 0 1px 3px ${colors.dark03}, 0 1px 2px ${colors.dark04};
    transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  }
  a {
    font-size: ${fonts.default}px;
    color: ${colors.grayDark};
    text-decoration: none;
  }
  #contentNuacom {
    display: flex;
    position: relative;
    flex: 1;
    height: 100%;
    flex-direction: column;
    max-width: ${measures.content.width}px;
    max-height: ${measures.content.height}px;
    overflow: hidden;

    &::-webkit-scrollbar { width: 0!important; height: 0!important; }
    overflow: -moz-scrollbars-none!important;
    -ms-overflow-style: none!important;
  }

  #mainContent {
    display: flex;
    flex: 1;
    flex-direction: column;
    background-color: ${colors.white};
    overflow: hidden!important;
    position: relative;
    justify-content: center;
  }

  .video-custom-toast {
    background-color: ${colors.white02} !important;
    color: ${colors.black} !important;
    font-size: 16px;
    border-radius: 8px!important;
    bottom: 60px;
    padding: 6px 6px 6px 18px !important;
    min-height: 50px !important;
  }
`;

export default GlobalStyle;
